<template>
  <v-card id="promotion-list">
    <v-card-text class="d-flex align-center flex-wrap pb-0">
      <div class="d-flex align-center pb-5">
        <v-btn
          color="primary"
          class="me-3"
          :disabled="hasNotPermission('Permissions.GroupCriteriaCreate')"
          @click="createDialogShow()"
        >
          <v-icon
            size="18"
            class="me-1"
          >
            {{ icons.mdiPlus }}
          </v-icon>
          <span>Добавить</span>
        </v-btn>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex align-center pb-5">
        <v-text-field
          v-model="filters.searchQuery"
          single-line
          dense
          outlined
          hide-details
          placeholder="Поиск..."
          class="promotion-list-search me-3"
        ></v-text-field>
      </div>
    </v-card-text>
    <v-data-table
      :headers="headers"
      :items="contacts"
      :server-items-length="totalCount"
      :loading="loading"
      :page.sync="filters.pageNumber"
      :items-per-page.sync="filters.pageSize"
      :sort-by.sync="filters.sortBy"
      :sort-desc.sync="filters.sortDesc"
      class="text-no-wrap"
    >
      <template #[`item.name`]="{item}">
        {{ item.name }}
      </template>
      <template #[`item.sex`]="{item}">
        <v-icon
          size="20"
          class="rounded-0"
        >
          {{ getIcon(item.sex) }}
        </v-icon>
      </template>
      <template #[`item.ageFrom`]="{item}">
        <span class="text-no-wrap">{{ item.ageFrom === null ? item.ageFrom : item.ageFrom + ' - ' + item.ageTo }}</span>
      </template>
      <template #[`item.dateOfBirth`]="{item}">
        <span class="text-no-wrap">{{ toDate(item.dateOfBirth) }}</span>
      </template>
      <template #[`item.actions`]="{item}">
        <div class="d-flex align-center justify-center">
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                :disabled="hasNotPermission('Permissions.GroupCriteriaUpdate')"
                v-bind="attrs"
                v-on="on"
                @click="updateDialogShow(item.id)"
              >
                <v-icon size="18">
                  {{ icons.mdiPencilOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Редактирование</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                :disabled="hasNotPermission('Permissions.GroupCriteriaDelete')"
                v-bind="attrs"
                v-on="on"
                @click="deletePopupShow(item.id, item.name)"
              >
                <v-icon size="18">
                  {{ icons.mdiDeleteOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>Удалить</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <delete-dialog
      ref="deletePopup"
      :label="deleteLabel"
      @delete-confirmed="deleteGroupCriteria"
    />
    <group-criteria-form
      :label="'Редактирование группы рассылки'"
      :cancellation="updateDialogCancel"
      :show="updateDialog"
      :save="updateGroupCriteria"
    ></group-criteria-form>
    <group-criteria-form
      :label="'Создание группы рассылки'"
      :cancellation="createDialogCancel"
      :show="createDialog"
      :save="addGroupCriteria"
    ></group-criteria-form>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import {
  mdiTrendingUp,
  mdiPlus,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiEyeOutline,
  mdiGenderMale,
  mdiGenderMaleFemale,
  mdiPencilOutline,
} from '@mdi/js'
import { mapFormHandlers } from '@/helpers/forms'
import DeleteDialog from '@/components/delete-dialog'
import GroupCriteriaForm from './group-criteria-form'
import { hasPermission, toDateSting } from '../../helpers/index'

export default {
  name: 'GroupCriteriaList',
  components: { DeleteDialog, GroupCriteriaForm },
  data: () => ({
    createDialog: false,
    updateDialog: false,
    icons: {
      mdiTrendingUp,
      mdiPlus,
      mdiPencilOutline,
      mdiDeleteOutline,
      mdiDotsVertical,
      mdiEyeOutline,
      mdiGenderMale,
      mdiGenderMaleFemale,
    },
    deleteLabel: '',
    deleteMethod: null,
  }),
  computed: {
    ...mapFormHandlers('groupCriteria', [
      'filters.pageNumber',
      'filters.pageSize',
      'filters.searchQuery',
      'filters.sortBy',
      'filters.sortDesc',
    ]),
    ...mapState('groupCriteria', {
      contacts: 'list',
      totalCount: 'totalCount',
      loading: 'loading',
    }),
    headers() {
      return [
        { text: 'Наименование', value: 'name' },
        { text: 'Пол', value: 'sex' },
        { text: 'Возраст', value: 'ageFrom' },
        { text: 'Дата рождения', value: 'dateOfBirth' },
        {
          text: 'Действия',
          value: 'actions',
          align: 'center',
          sortable: false,
        },
      ]
    },
  },
  async created() {
    document.title = 'Группы рассылки'
    this.fetchGroupCriteria()
  },
  methods: {
    ...mapActions('groupCriteria', {
      fetchGroupCriteria: 'fetchList',
      deleteGroupCriteria: 'delete',
    }),
    ...mapActions('groupCriteria/form', ['create', 'resetForm', 'fetchById', 'update']),
    hasNotPermission(val) {
      return !hasPermission(val)
    },
    deletePopupShow(id, name) {
      this.deleteLabel = `Группа рассылки ${name} будет удалена.`
      this.$refs.deletePopup.open(id)
    },
    async addGroupCriteria() {
      await this.create()
      this.createDialog = false
    },
    async updateGroupCriteria() {
      await this.update()
      this.updateDialog = false
    },
    toDate(val) {
      return toDateSting(val)
    },
    createDialogShow() {
      this.createDialog = true
    },
    getIcon(val) {
      switch (val) {
        case 1:
          return this.icons.mdiGenderMale
        case 2:
          return this.icons.mdiGenderMaleFemale
      }
    },
    createDialogCancel() {
      this.createDialog = false
    },
    updateDialogCancel() {
      this.updateDialog = false
    },
    updateDialogShow(id) {
      this.fetchById(id)
      this.updateDialog = true
    },
  },
}
</script>

<style lang="scss" scoped>
#promotion-list {
  .promotion-list-search {
    max-width: 10.625rem;
  }
}
</style>
